<template>
     <section class="home-page__news" v-if="featuredNews.length > 0">        
            <div class="container-xl">
                <div class="main-page-block">
                    <div class="row">
                        <div class="col-12 col-lg-6 home-page__news-youtube">
                            <h3>{{lang('fooldal_reklamfilmjeink')}}</h3>
                            <div class="youtube-block">
                                <div class="news-item-outerwrap">
                                     <NewsItemYoutube v-for="news in bigYoutube" :key="news.id"
                                        :name="news.name"
                                        :id="news.id"                                  
                                        :news_slug="news.slug"
                                        :youtube_id="news.youtube_id"
                                        :srcset="itemSrcset(news)" 
                                        :src="itemSrc(news, 'w1120h620')"
                                        :srcsizes="'(max-width: 767px) 740px, 768px'"
                                    />
                                </div>
                                <div class="news-item-outerwrap" v-for="news in youtubeNews" :key="news.id">
                                    <NewsItemYoutube 
                                        :name="news.name"
                                        :id="news.id"                                  
                                        :news_slug="news.slug"
                                        :youtube_id="news.youtube_id"
                                        :srcset="itemSrcset(news)" 
                                        :src="itemSrc(news, 'w340h188')"
                                        :srcsizes="'(max-width: 767px) 260px, 170px'"
                                    />                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 home-page__news-news">
                            <div class="title">
                                <h3>{{lang('fooldal_aktualitasaink')}}</h3>
                                <router-link class="btn btn--green-border" :to="{ name:'NewsAll_' + currentLangName()}">
                                    {{ lang('fooldal_osszes_hir')}}
                                </router-link>
                            </div>                            
                            <div class="row" v-if="actualNews.length>0">
                                <div class="col-12 col-md-6 news-item-outerwrap" v-for="news in actualNews" :key="news.id">
                                    <NewsItem
                                        :name="news.name"
                                        :date="dateFormatted(news.published_date)"
                                        :id="news.id"                                  
                                        :news_slug="news.slug"
                                        :short_description="news.short_description"
                                    />
                                </div>
                                <div class="col-12 go-all-news-btn-wrap--mobile">
                                    <router-link class="btn btn--green-border" :to="{ name:'NewsAll_' + currentLangName()}">
                                        {{ lang('fooldal_osszes_hir')}}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                                   
                </div>
            </div>
        </section>  
</template>

<script>
import axios from 'axios'
import NewsItem from '@/components/pagesComponents/news/NewsItem.vue'
import NewsItemYoutube from '@/components/pagesComponents/news/NewsItemYoutube.vue'

export default {
    data(){
        return{
            featuredNews: [],
            actualNews: [],
            youtubeNews: [],
            bigYoutube: []                      
        }
    },
    components:{
        NewsItem,
        NewsItemYoutube
    },
    methods:{
        setFeaturedNews(){                                                   
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/filter/59?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information][order_by][1][0]=published_date&relations_params[information][order_by][1][1]=desc',{
            params:{
                "language_id": this.$store.getters.getSelectedLang.id              
            }
            }).then(response => {                               
                if (response.data.status === true ){                    
                    if (response.data.filter[0].information){
                        this.featuredNews = response.data.filter[0].information  
                        this.selectFeaturedNews()                       
                    } else {
                        this.featuredNews = []
                        this.actualNews = []
                        this.youtubeNews = []
                        this.bigYoutube = []   
                    }
                    
                } else {
                    this.featuredNews = []
                    this.actualNews = []
                    this.youtubeNews = []
                    this.bigYoutube = [] 
                }             
            })
            .catch((err) => {
                console.log(err)
            });                
        },  
        dateFormatted(dateString){
            let date =  dateString.slice(0,10)      
            let formattedDate = date.replace(/-/g, ".");       
            return formattedDate
        },
        selectFeaturedNews(){
            let newsArray = []
            let youtubeArray = []
            let categoryArray = this.$store.getters.getNewsCategory;  
            let _this = this;

            this.featuredNews.forEach(item => {                                 
                let itemCategory = _this.getCategoryData(item.id, categoryArray  )
                let category27Index = itemCategory.findIndex(x => parseInt(x.id) === 27 );                

                if ( category27Index > -1 && (item.youtube_id != null || item.youtube_id != '' || item.youtube_id != undefined)){
                    if (_this.bigYoutube.length == 0){
                        _this.bigYoutube.push(item)
                    }else {
                        youtubeArray.push(item)
                    }
                    
                } else {
                    newsArray.push(item)
                }
            })

            this.actualNews = newsArray;
            this.youtubeNews = youtubeArray;

        }     
    },
    created(){
        this.setFeaturedNews()
    }
}
</script>